<template>
  <div>
    <TsCardOpinionProduct :bannerImage="`${background.desktopBannerImage}?format=webp`"
                          :imgMobile="`${background.mobileBannerImage}?format=webp`" frontClass="-mt-[250px] sm:-mt-[650px] md:-mt-[150px] lg:-mt-[250px] w-full">
      <template #front>
        <div v-if="props.productIds" class="lg:px-2">
          <TsCarouselCardProduct
              :button-outlined="false"
              :navigation="!isMobile"
              data-testid="home-product-carousel"
              productContextType="recommended"
              :product-ids="props.productIds"
          />
        </div>
      </template>
    </TsCardOpinionProduct>
  </div>
</template>

<script setup lang="ts">
const { isMobile } = useDevice();

const TsCardOpinionProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCardOpinionProduct.vue')
);

const TsCarouselCardProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselCardProduct.vue')
);

type Props = {
    breakpoints?: object,
    dataTestid?: string,
    productIds?: string;
  background?: { desktopBannerImage: string, mobileBannerImage: string };
}

const props = withDefaults(defineProps<Props>(), {
  productIds: '99532, 98882, 93157, 97700, 13548, 13772',
  background: () => ({ desktopBannerImage: '/images/recommended-products-banner.webp', mobileBannerImage: '/images/recommended-products-banner-mobile.webp' })
})
</script>
